window.bundleDataM = {
"Maddox-boy": {
displayName: "Maddox",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maddox Personalized Coloring Experience",
variantId: "49402666811629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MADDOXFINALCOVER.png?v=1771817961",
price: "$14.99",
preorder: true
},
{
title: "Maddox Dragon Holographic Sticker",
variantId: "49933768458477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maddox_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Maddox Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Madeline-girl": {
displayName: "Madeline",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Madeline Personalized Coloring Experience",
variantId: "49577411674349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Madeline_final_cover.png?v=1773369575",
price: "$14.99",
preorder: true
},
{
title: "Madeline Unicorn Holographic Sticker",
variantId: "49933756661997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Madeline_holographic_sticker.png?v=1780099046",
price: "$4.99",
preorder: false
},
{
title: "Madeline Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Madelyn-girl": {
displayName: "Madelyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Madelyn Personalized Coloring Experience",
variantId: "49578310697197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Madelyn_final_cover.png?v=1773369574",
price: "$14.99",
preorder: true
},
{
title: "Madelyn Unicorn Holographic Sticker",
variantId: "49933756563693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Madelyn_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Madelyn Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Madison-girl": {
displayName: "Madison",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Madison Personalized Coloring Experience",
variantId: "49279570772205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Madison_final_cover.png?v=1773766538",
price: "$14.99",
preorder: true
},
{
title: "Madison Unicorn Holographic Sticker",
variantId: "49933774749933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Madison_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Madison Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Madisyn-girl": {
displayName: "Madisyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Madisyn Personalized Coloring Experience",
variantId: "49801320857837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Madisyn_final_cover.png?v=1775415295",
price: "$14.99",
preorder: true
},
{
title: "Madisyn Unicorn Holographic Sticker",
variantId: "49933752729837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Madisyn_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Madisyn Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Maeve-girl": {
displayName: "Maeve",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maeve Personalized Coloring Experience",
variantId: "49580663701741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maeve_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Maeve Unicorn Holographic Sticker",
variantId: "49933756334317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maeve_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Maeve Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Magnus-boy": {
displayName: "Magnus",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Magnus Personalized Coloring Experience",
variantId: "49731874095341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Magnus_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Magnus Dragon Holographic Sticker",
variantId: "49933753450733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Magnus_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Magnus Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Maisie-girl": {
displayName: "Maisie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maisie Personalized Coloring Experience",
variantId: "49580180275437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maisie_final_cover.png?v=1773369573",
price: "$14.99",
preorder: true
},
{
title: "Maisie Unicorn Holographic Sticker",
variantId: "49933756399853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maisie_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Maisie Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Manuel-boy": {
displayName: "Manuel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Manuel Personalized Coloring Experience",
variantId: "49402670711021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MANUELFINALCOVER.png?v=1771818084",
price: "$14.99",
preorder: true
},
{
title: "Manuel Dragon Holographic Sticker",
variantId: "49933768425709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Manuel_holographic_sticker.png?v=1779648206",
price: "$4.99",
preorder: false
},
{
title: "Manuel Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Margot-girl": {
displayName: "Margot",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Margot Personalized Coloring Experience",
variantId: "49801333080301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Margot_final_cover.png?v=1775415417",
price: "$14.99",
preorder: true
},
{
title: "Margot Unicorn Holographic Sticker",
variantId: "49933746241773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Margot_holographic_sticker.png?v=1780099053",
price: "$4.99",
preorder: false
},
{
title: "Margot Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Maria-girl": {
displayName: "Maria",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maria Personalized Coloring Experience",
variantId: "49578569990381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maria_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Maria Unicorn Holographic Sticker",
variantId: "49933756530925",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maria_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Maria Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Maribel-girl": {
displayName: "Maribel",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maribel Personalized Coloring Experience",
variantId: "49274390905069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maribel_final_cover.png?v=1773766534",
price: "$14.99",
preorder: true
},
{
title: "Maribel Unicorn Holographic Sticker",
variantId: "49933780779245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maribel_holographic_sticker.png?v=1780099044",
price: "$4.99",
preorder: false
},
{
title: "Maribel Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Marie-girl": {
displayName: "Marie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Marie Personalized Coloring Experience",
variantId: "49983111889133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mariefinalcover.png?v=1779026862",
price: "$14.99",
preorder: true
},
{
title: "Marie Unicorn Holographic Sticker",
variantId: "49983087902957",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Marie_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Marie Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Mark-boy": {
displayName: "Mark",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mark Personalized Coloring Experience",
variantId: "49402675200237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MARKFINALCOVER.png?v=1771818236",
price: "$14.99",
preorder: true
},
{
title: "Mark Dragon Holographic Sticker",
variantId: "49933768392941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mark_holographic_sticker.png?v=1779648213",
price: "$4.99",
preorder: false
},
{
title: "Mark Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mason-boy": {
displayName: "Mason",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mason Personalized Coloring Experience",
variantId: "49402677166317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MASONFINALCOVER.png?v=1771818392",
price: "$14.99",
preorder: true
},
{
title: "Mason Dragon Holographic Sticker",
variantId: "49933768360173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mason_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Mason Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mateo-boy": {
displayName: "Mateo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mateo Personalized Coloring Experience",
variantId: "49397515976941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mateofinalcover.png?v=1771598033",
price: "$14.99",
preorder: true
},
{
title: "Mateo Dragon Holographic Sticker",
variantId: "49933770326253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mateo_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Mateo Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Matias-boy": {
displayName: "Matias",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Matias Personalized Coloring Experience",
variantId: "49406690394349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MATIAS_FINAL_COVER.png?v=1771894575",
price: "$14.99",
preorder: true
},
{
title: "Matias Dragon Holographic Sticker",
variantId: "49933767770349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Matias_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Matias Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Matteo-boy": {
displayName: "Matteo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Matteo Personalized Coloring Experience",
variantId: "49265070440685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Matteo_final_cover.png?v=1772675159",
price: "$14.99",
preorder: true
},
{
title: "Matteo Dragon Holographic Sticker",
variantId: "49933781565677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Matteo_holographic_sticker.png?v=1779648204",
price: "$4.99",
preorder: false
},
{
title: "Matteo Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Matthew-boy": {
displayName: "Matthew",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Matthew Personalized Coloring Experience",
variantId: "49397519253741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Matthewfinalcover.png?v=1771598174",
price: "$14.99",
preorder: true
},
{
title: "Matthew Dragon Holographic Sticker",
variantId: "49933770260717",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Matthew_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Matthew Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Maverick-boy": {
displayName: "Maverick",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maverick Personalized Coloring Experience",
variantId: "49279570837741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maverickfinalcover.png?v=1771571901",
price: "$14.99",
preorder: true
},
{
title: "Maverick Dragon Holographic Sticker",
variantId: "49933774684397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maverick_holographic_sticker.png?v=1779648203",
price: "$4.99",
preorder: false
},
{
title: "Maverick Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Max-boy": {
displayName: "Max",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Max Personalized Coloring Experience",
variantId: "49406692491501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MAX_FINAL_COVER.png?v=1771894576",
price: "$14.99",
preorder: true
},
{
title: "Max Dragon Holographic Sticker",
variantId: "49933767737581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Max_holographic_sticker.png?v=1779648204",
price: "$4.99",
preorder: false
},
{
title: "Max Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Maximiliano-boy": {
displayName: "Maximiliano",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maximiliano Personalized Coloring Experience",
variantId: "49406693114093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MAXIMILIANO_FINAL_COVER.png?v=1771894576",
price: "$14.99",
preorder: true
},
{
title: "Maximiliano Dragon Holographic Sticker",
variantId: "49933767704813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maximiliano_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Maximiliano Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Maximus-boy": {
displayName: "Maximus",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maximus Personalized Coloring Experience",
variantId: "49406693736685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MAXIMUS_FINAL_COVER.png?v=1771894575",
price: "$14.99",
preorder: true
},
{
title: "Maximus Dragon Holographic Sticker",
variantId: "49933767672045",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maximus_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Maximus Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Maxwell-boy": {
displayName: "Maxwell",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maxwell Personalized Coloring Experience",
variantId: "49400184144109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maxwell_final_cover.png?v=1771691711",
price: "$14.99",
preorder: true
},
{
title: "Maxwell Dragon Holographic Sticker",
variantId: "49933768982765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maxwell_holographic_sticker.png?v=1779648211",
price: "$4.99",
preorder: false
},
{
title: "Maxwell Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Maya-girl": {
displayName: "Maya",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Maya Personalized Coloring Experience",
variantId: "49279571067117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maya_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Maya Unicorn Holographic Sticker",
variantId: "49933774586093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Maya_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Maya Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Megan-girl": {
displayName: "Megan",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Megan Personalized Coloring Experience",
variantId: "49279571132653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Megan_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Megan Unicorn Holographic Sticker",
variantId: "49933774520557",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Megan_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Megan Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Melanie-girl": {
displayName: "Melanie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Melanie Personalized Coloring Experience",
variantId: "49279571198189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Melanie_final_cover.png?v=1773766537",
price: "$14.99",
preorder: true
},
{
title: "Melanie Unicorn Holographic Sticker",
variantId: "49933774455021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Melanie_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Melanie Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Melissa-girl": {
displayName: "Melissa",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Melissa Personalized Coloring Experience",
variantId: "49577412428013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Melissa_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Melissa Unicorn Holographic Sticker",
variantId: "49933756629229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Melissa_holographic_sticker.png?v=1780099053",
price: "$4.99",
preorder: false
},
{
title: "Melissa Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Melody-girl": {
displayName: "Melody",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Melody Personalized Coloring Experience",
variantId: "49581446562029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Melody_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Melody Unicorn Holographic Sticker",
variantId: "49933756301549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Melody_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Melody Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Mia-girl": {
displayName: "Mia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mia Personalized Coloring Experience",
variantId: "49578843373805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mia_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Mia Unicorn Holographic Sticker",
variantId: "49933756498157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mia_holographic_sticker.png?v=1780099052",
price: "$4.99",
preorder: false
},
{
title: "Mia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Micah-boy": {
displayName: "Micah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Micah Personalized Coloring Experience",
variantId: "49441961312493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Micahfinalcover.png?v=1772581837",
price: "$14.99",
preorder: true
},
{
title: "Micah Dragon Holographic Sticker",
variantId: "49933759643885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Micah_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Micah Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Michael-boy": {
displayName: "Michael",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Michael Personalized Coloring Experience",
variantId: "49406694129901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MICHAEL_FINAL_COVER.png?v=1771894580",
price: "$14.99",
preorder: true
},
{
title: "Michael Dragon Holographic Sticker",
variantId: "49933767639277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Michael_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Michael Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Michelle-girl": {
displayName: "Michelle",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Michelle Personalized Coloring Experience",
variantId: "49580436259053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Michelle_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Michelle Unicorn Holographic Sticker",
variantId: "49933756367085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Michelle_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Michelle Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Miguel-boy": {
displayName: "Miguel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Miguel Personalized Coloring Experience",
variantId: "49406701469933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MIGUEL_FINAL_COVER.png?v=1771894576",
price: "$14.99",
preorder: true
},
{
title: "Miguel Dragon Holographic Sticker",
variantId: "49933767606509",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Miguel_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Miguel Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mike-boy": {
displayName: "Mike",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mike Personalized Coloring Experience",
variantId: "49431482925293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mike_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Mike Dragon Holographic Sticker",
variantId: "49933759840493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mike_holographic_sticker.png?v=1780106112",
price: "$4.99",
preorder: false
},
{
title: "Mike Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mila-girl": {
displayName: "Mila",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mila Personalized Coloring Experience",
variantId: "49279571296493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mila_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Mila Unicorn Holographic Sticker",
variantId: "49933774356717",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mila_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Mila Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Miles-boy": {
displayName: "Miles",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Miles Personalized Coloring Experience",
variantId: "49400186863853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Miles_final_cover.png?v=1771691712",
price: "$14.99",
preorder: true
},
{
title: "Miles Dragon Holographic Sticker",
variantId: "49933768949997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Miles_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Miles Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Millie-girl": {
displayName: "Millie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Millie Personalized Coloring Experience",
variantId: "49801332130029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Millie_final_cover.png?v=1775415417",
price: "$14.99",
preorder: true
},
{
title: "Millie Unicorn Holographic Sticker",
variantId: "49933746274541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Millie_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Millie Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Milo-boy": {
displayName: "Milo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Milo Personalized Coloring Experience",
variantId: "49299071402221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Milo_final_cover.png?v=1772753294",
price: "$14.99",
preorder: true
},
{
title: "Milo Dragon Holographic Sticker",
variantId: "49933772652781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Milo_holographic_sticker.png?v=1780106107",
price: "$4.99",
preorder: false
},
{
title: "Milo Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mira-girl": {
displayName: "Mira",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mira Personalized Coloring Experience",
variantId: "49581664174317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mira_final_cover.png?v=1773369576",
price: "$14.99",
preorder: true
},
{
title: "Mira Unicorn Holographic Sticker",
variantId: "49933756268781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mira_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Mira Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Mitchel-boy": {
displayName: "Mitchel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mitchel Personalized Coloring Experience",
variantId: "49472180224237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mitchel_final_cover.png?v=1772930017",
price: "$14.99",
preorder: true
},
{
title: "Mitchel Dragon Holographic Sticker",
variantId: "49933759086829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mitchel_holographic_sticker.png?v=1780106111",
price: "$4.99",
preorder: false
},
{
title: "Mitchel Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mitchell-boy": {
displayName: "Mitchell",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mitchell Personalized Coloring Experience",
variantId: "49472180715757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mitchell_final_cover.png?v=1772930023",
price: "$14.99",
preorder: true
},
{
title: "Mitchell Dragon Holographic Sticker",
variantId: "49933759054061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mitchell_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Mitchell Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mohamed-boy": {
displayName: "Mohamed",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mohamed Personalized Coloring Experience",
variantId: "49406706024685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MOHAMED_FINAL_COVER.png?v=1771894575",
price: "$14.99",
preorder: true
},
{
title: "Mohamed Dragon Holographic Sticker",
variantId: "49933767573741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mohamed_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Mohamed Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mohammad-boy": {
displayName: "Mohammad",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mohammad Personalized Coloring Experience",
variantId: "49406707204333",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MOHAMMAD_FINAL_COVER.png?v=1771894576",
price: "$14.99",
preorder: true
},
{
title: "Mohammad Dragon Holographic Sticker",
variantId: "49933767540973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mohammad_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Mohammad Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Mohammed-boy": {
displayName: "Mohammed",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mohammed Personalized Coloring Experience",
variantId: "49406707728621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MOHAMMED_FINAL_COVER.png?v=1771894576",
price: "$14.99",
preorder: true
},
{
title: "Mohammed Dragon Holographic Sticker",
variantId: "49933767508205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mohammed_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Mohammed Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Monroe-girl": {
displayName: "Monroe",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Monroe Personalized Coloring Experience",
variantId: "49754284425453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Monroe_final_cover.png?v=1775322363",
price: "$14.99",
preorder: true
},
{
title: "Monroe Unicorn Holographic Sticker",
variantId: "49933753188589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Monroe_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Monroe Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Muhammad-boy": {
displayName: "Muhammad",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Muhammad Personalized Coloring Experience",
variantId: "49406708383981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/MUHAMMAD_FINAL_COVER.png?v=1771894575",
price: "$14.99",
preorder: true
},
{
title: "Muhammad Dragon Holographic Sticker",
variantId: "49933767475437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Muhammad_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Muhammad Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Myra-girl": {
displayName: "Myra",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Myra Personalized Coloring Experience",
variantId: "49579041390829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Myra_final_cover.png?v=1773369575",
price: "$14.99",
preorder: true
},
{
title: "Myra Unicorn Holographic Sticker",
variantId: "49933756465389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Myra_holographic_sticker.png?v=1780099047",
price: "$4.99",
preorder: false
},
{
title: "Myra Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Mindy-girl": {
displayName: "Mindy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mindy Personalized Coloring Experience",
variantId: "50042187645165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mindy_final_cover_a3ed5214-f1b5-4d39-98a1-0ebec855bbf6.png?v=1780107433",
price: "$14.99",
preorder: true
},
{
title: "Mindy Unicorn Holographic Sticker",
variantId: "50042172637421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mindy_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Mindy Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Melinda-girl": {
displayName: "Melinda",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Melinda Personalized Coloring Experience",
variantId: "50042204422381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Melinda_final_cover_e9a61e95-8710-41aa-8d99-5b0414860dff.png?v=1780107442",
price: "$14.99",
preorder: true
},
{
title: "Melinda Unicorn Holographic Sticker",
variantId: "50042173489389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Melinda_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Melinda Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Mary-girl": {
displayName: "Mary",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mary Personalized Coloring Experience",
variantId: "50078287495405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mary_final_cover.png?v=1780809464",
price: "$14.99",
preorder: true
},
{
title: "Mary Unicorn Holographic Sticker",
variantId: "50077634855149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mary_sticker_website.png?v=1780804205",
price: "$4.99",
preorder: false
},
{
title: "Mary Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Margaret-girl": {
displayName: "Margaret",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Margaret Personalized Coloring Experience",
variantId: "50078312890605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Margaret_final_cover.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Margaret Unicorn Holographic Sticker",
variantId: "50077639016685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Margaret_sticker_website.png?v=1780804205",
price: "$4.99",
preorder: false
},
{
title: "Margaret Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Myles-boy": {
displayName: "Myles",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Myles Personalized Coloring Experience",
variantId: "50126013104365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Myles_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Myles Dragon Holographic Sticker",
variantId: "50127074656493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mylesstickerwebsite.png?v=1781967787",
price: "$4.99",
preorder: false
},
{
title: "Myles Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Malachi-boy": {
displayName: "Malachi",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Malachi Personalized Coloring Experience",
variantId: "50127708553453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Malachi_final_cover.png?v=1781988267",
price: "$14.99",
preorder: true
},
{
title: "Malachi Dragon Holographic Sticker",
variantId: "50127679979757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Malachiwebsitesticker.png?v=1781987378",
price: "$4.99",
preorder: false
},
{
title: "Malachi Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},

"Messiah-boy": {
displayName: "Messiah",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Messiah Personalized Coloring Experience",
variantId: "50180876173549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Messiah_final_cover.png?v=1782611298",
price: "$14.99",
preorder: true
},
{
title: "Messiah Dragon Holographic Sticker",
variantId: "50180841898221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Messiahwebsitesticker.png?v=1782611155",
price: "$4.99",
preorder: false
},
{
title: "Messiah Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Magnolia-girl": {
displayName: "Magnolia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Magnolia Personalized Coloring Experience",
variantId: "50246006505709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Magnolia_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Magnolia Unicorn Holographic Sticker",
variantId: "50259972161773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Magnolia_holographic_sticker.png?v=1783785471",
price: "$4.99",
preorder: false
},
{
title: "Magnolia Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Mackenzie-girl": {
displayName: "Mackenzie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mackenzie Personalized Coloring Experience",
variantId: "50246105333997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mackenzie_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Mackenzie Unicorn Holographic Sticker",
variantId: "50260013121773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mackenzie_holographic_sticker.png?v=1783785471",
price: "$4.99",
preorder: false
},
{
title: "Mackenzie Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Molly-girl": {
displayName: "Molly",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Molly Personalized Coloring Experience",
variantId: "50305372160237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mollyfinalcover.png?v=1784421454",
price: "$14.99",
preorder: true
},
{
title: "Molly Unicorn Holographic Sticker",
variantId: "50305506705645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Molly_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Molly Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Marcus-boy": {
displayName: "Marcus",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Marcus Personalized Coloring Experience",
variantId: "50399296159981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Marcus_final_cover.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Marcus Dragon Holographic Sticker",
variantId: "50399572459757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Marcus_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Marcus Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Malakai-boy": {
displayName: "Malakai",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Malakai Personalized Coloring Experience",
variantId: "50399860949229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Malakaifinalcover.png?v=1785906579",
price: "$14.99",
preorder: true
},
{
title: "Malakai Dragon Holographic Sticker",
variantId: "50449531928813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Malakai_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Malakai Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Myla-girl": {
displayName: "Myla",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Myla Personalized Coloring Experience",
variantId: "50519288578285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Myla_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Myla Unicorn Holographic Sticker",
variantId: "50497559527661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Myla_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Myla Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Morgan-girl": {
displayName: "Morgan",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Morgan Personalized Coloring Experience",
variantId: "50594647081197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Morgan_final_cover.png?v=1788155669",
price: "$14.99",
preorder: true
},
{
title: "Morgan Unicorn Holographic Sticker",
variantId: "50603374608621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Morganholographicsticker.png?v=1788215244",
price: "$4.99",
preorder: false
},
{
title: "Morgan Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Mariana-girl": {
displayName: "Mariana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Mariana Personalized Coloring Experience",
variantId: "50643941458157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mariana_final_cover.png?v=1788490620",
price: "$14.99",
preorder: true
},
{
title: "Mariana Unicorn Holographic Sticker",
variantId: "50643955319021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Mariana_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Mariana Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 






};